import { createUseStyles } from "react-jss";
//import { apaTheme } from "../../../constants/theme";

export const useStyles = () => {
  return createUseStyles({
    container: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      width: "100%",
    },
    rowWrapper: {
      display: "flex",
      flexDirection: "row",
      gap: "16px",
      alignItems: "center",
      width: '100%'
    },
    checkBoxAndSectionWrapper: {
      display: "flex",
      flexDirection: "row",
      width: "100%",
    },
    label: {
      color: "#6B6B6C",
      fontWeight: "400",
      fontSize: "12px",
    },
    value: {
      color: "#2F2F2F",
      fontWeight: "400",
      fontSize: "14px",
    },
    selectedRowWrapper: {
      position: "absolute",
      right: 0,
      top: "50%",
      transform: "translateY(-50%)",
      display: "flex",
      background: "white",
      padding: "4px 8px",
      borderRadius: 4,
      zIndex: 1,
    },
    tableContainer: {
      backgroundColor: "white",
      boxShadow: "none",
    },
    tableHead: {
      color: "#475467",
      fontWeight: 600,
      fontSize: "14px",
      border: "0.5px solid #F8F8F8",
    },
    cell: {
      padding: "14px",
      color: "#475467",
      border: "0.5px solid #F8F8F8",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "150px", // Limits cell width
      minWidth: "50px", // Prevents shrinking too much
    },
    cellDone: {
      padding: "14px",
      color: "#139511",
      border: "0.5px solid #F8F8F8",
    },
    selectedCell: {
      fontWeight: 500,
    },
    updateToSubscriptionContainer: {
      display: "flex",
      padding: "8px 8px",
      gap: "8px",
      alignItems: "flex-start",
      flexDirection: "column",
      backgroundColor: "#FDFDFD",
    },
    upgradeSubscriptionTitle: {
      color: "#2F2F2F",
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
      padding: "8px",
    },
    subInfoGeneralContainer: {
      display: "flex",
      padding: "2px",
      alignItems: "center",
      justifyContent: "space-between",
      alignSelf: "stretch",
      backgroundColor: "#F8F8F8",
    },
    subInfoWrapper: {
      display: "flex",
      height: "42px",
      width: "110px",
      padding: "8px",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      gap: "4px",
      backgroundColor: "#FDFDFD",
    },
    subInfoLabel: {
      color: "#6B6B6C",
      fontSize: "12px",
      fontWeight: 400,
      lineHeight: "14px",
    },
    subInfoValue: {
      color: "#2F2F2F",
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
    },
  })();
};
